// this file contain the api arround pouchdb, so that the details of getting the info are hidden

import * as PouchDB from './PouchDB';
import * as Api from './Api';

const createFileHandle = (url, release) => ({url, release});

export const releaseFile = fileHandle => {
    if (fileHandle && typeof fileHandle.release === "function") {
        fileHandle.release();
    }
}

export const getFile = async (fileId, incidentId) => {
    try {
        const source = await PouchDB.resolveFileSource(fileId, incidentId);
        if (!source) {
            return null;
        }

        if (source.type === "remote") {
            return createFileHandle(Api.getImageFullUrl(source.serverURL), () => {});
        }

        return null;
    } catch (err) {
        console.log("error retrieving pouch doc for file " + fileId);
        console.log(err);

        return null;
    }
}
